<template>
    <div class="applyform">
        <div class="body">
            <div class="body-content">
                <div class="fontSize4 body-main">
                    <div class="body-title">
                        申请试用
                    </div>
                    <div class="close">
                        <span @click="setApplyformShow(false)" class="iconfont icon-guanbi1"></span>
                    </div>
                    <!-- 试用规则 -->
                    <div class="rule-row">
                        <div class="rule-header" @click="toggleRuleShow">
                            <span class="rule-title">试用规则</span>
                            <span class="rule-icon" :class="{ expanded: showRule }">▼</span>
                        </div>
                        <div class="rule-content" v-show="showRule" v-html="detail_rule_pc"></div>
                    </div>

                    <div class="row">
                        <label for="name">姓名</label>
                        <input class="fontSize4 row_input" type="text" id="name" v-model="truename" />
                    </div>
                    <div class="row">
                        <label for="phone">手机号</label>
                        <input class="fontSize4" type="text" id="phone" v-model="tel" />
                    </div>
                    <div class="row">
                        <label for="email">企业邮箱</label>
                        <input class="fontSize4" type="text" id="email" v-model="email" />
                    </div>
                    <div class="row" v-clickoutside="companyListHide">
                        <label for="company">公司全称</label>
                        <input class="fontSize4" type="text" id="company" v-model="company" @input="companyOnInput" />
                        <ul class="company-list" v-show="companyListShow">
                            <li @click="companyLiClick(item)" v-for="(item, index) in companyList" :key="index">
                                {{ item }}
                            </li>
                        </ul>
                    </div>
                    <div v-show="false" class="row">
                        <label for="address">收货地址</label>
                        <input class="fontSize4" type="text" id="address" v-model="address" />
                    </div>

                    <!-- 展开更多信息的描述和按钮 -->
                    <div class="row expand-more-row">
                        <div class="expand-more-text" @click="toggleMoreFields">
                            <span class="expand-text">下拉填写更多，会更容易获得试用机会哦</span>
                            <span class="expand-icon" :class="{ expanded: showMoreFields }">▼</span>
                        </div>
                    </div>

                    <!-- 三个下拉字段 -->
                    <div v-show="showMoreFields" class="more-fields">
                        <div class="row">
                            <label for="position">职务</label>
                            <CustomSelect id="position" :options="positionOptions" v-model="position"
                                placeholder="请选择职务" label="职务"></CustomSelect>
                        </div>

                        <div class="row">
                            <label for="companySize">公司规模</label>
                            <CustomSelect id="companySize" :options="companySizeOptions" v-model="companySize"
                                placeholder="请选择公司规模" label="公司规模"></CustomSelect>
                        </div>

                        <div class="row">
                            <label for="useCase">使用场景</label>
                            <input class="fontSize4" type="text" id="useCase" v-model="useCase" />
                        </div>
                    </div>

                    <div class="row">
                        <label class="textarea-label" style="" for="reason">申请理由（5-150字）</label>
                        <textarea class="fontSize4" v-model="reason" name="" id="reason" cols="30" rows="10">
						</textarea>
                    </div>
                    <div class="row yinsi-div">
                        <input class="checkbox" type="checkbox" id="tongyi" v-model="tongyi" />
                        <label for="tongyi" class="yinsi-text" style="font-size: 12px;">
                            <span class="text-check"></span>
                            我了解并同意以下内容：戴尔按照<a target="_blank" rel="noopener noreferrer" href="https://www.dell.com/zh-cn/lp/legal/policies-privacy" class="text-blue">《隐私声明》</a>所述，根据《个人信息保护法》的规定，将本人个人信息传输、存储至戴尔美国总部进行处理。要详细了解戴尔如何使用、共享和保护您的个人数据，请参阅我们的 <a target="_blank" rel="noopener noreferrer" href="https://www.dell.com/zh-cn/lp/legal/policies-privacy" class="text-blue">隐私声明</a>。<br>
                            <div class="privacy-statement-text" style="font-size: 12px; margin-top: 10px;">单击"申请试用"，即表示您同意 <a target="_blank" rel="noopener noreferrer" href="https://investors.delltechnologies.com/node/11831/html" class="text-blue">Dell Technologies 及其公司集团</a>（简称"戴尔"）通过电子邮件、电话或短信与您保持联系。戴尔及其销售代表将向您提供有关产品、服务、解决方案、专享优惠和特别活动的最新信息。有关信息处理方式的更多详细信息，请参见我们的 <a target="_blank" rel="noopener noreferrer" href="https://www.dell.com/zh-cn/lp/legal/policies-privacy" class="text-blue">隐私声明</a>。您可以随时取消订阅。</div>
                        </label>
                    </div>
                    <div class="row">
                        <button :class="{ disabled: !tongyi }" @click="submit" class="fontSize2 btn">申请试用 ></button>
                    </div>
                </div>
            </div>
        </div>
        <div @touchmove.prevent v-show="showApplyConfirm" class="apply-mask"></div>
        <div @touchmove.prevent v-show="showApplyConfirm" class="applyConfirm">
            <div class="content">
                <div class="title">申请成功！</div>
                <div class="coupon-infor" v-if="hasCoupon">恭喜您获得{{ couponTitle }}</div>
                <div class="text">邀请好友点赞，赞数越高，申请成功的概率越大</div>
                <img class="coupon-img" v-if="hasCoupon" :src="couponImg" alt="">
                <img class="success-img" v-if="!hasCoupon" src="~@/assets/detail/apply-success.png" alt="">
                <div class="btnGroup">
                    <template v-if="!hasCoupon">
                        <button @click="cancel" class="btn-line">关　闭 ></button>
                        <button @click="go">邀请点赞 ></button>
                        <button @click="go">获取结果通知 ></button>
                    </template>
                    <template v-else>
                        <button @click="go" class="btn-line">邀请点赞 ></button>
                        <button @click="clickCoupon">立即使用 ></button>
                    </template>
                </div>
            </div>
            <div class="close-icon" @click="cancel">
                <span class="iconfont icon-guanbi1"></span>
            </div>
        </div>

        <div v-show="showApplyAlert" class="applyAlert">
            <div class="body2">
                <div v-html="site_yhxy"></div>
                <img @click="showApplyAlert = false" class="close" src="@/assets/close3.png" />
            </div>
        </div>

        <!-- Toast组件 -->
        <Toast ref="toast" />
    </div>

</template>
<script>
import { mapState } from 'vuex'
import CustomSelect from './CustomSelect.vue'
import Toast from './Toast.vue'

export default {
    name: 'applyform',
    components: {
        CustomSelect,
        Toast
    },
    data() {
        return {
            showApplyConfirm: false,
            truename: '',
            tel: '',
            email: '',
            company: '',
            address: '',
            reason: '',
            submitIng: false,
            tongyi: '',
            showApplyAlert: false,
            companyListShow: false,
            companyList: [],
            companySearch: false,
            companySetTime: undefined,
            ifMatchingcompanyName: false,
            // 新增的字段
            showMoreFields: false,
            position: '',
            companySize: '',
            useCase: '',
            showRule: false,
            positionOptions: [
                { text: 'IT经理', value: 'IT经理' },
                { text: 'C-Level高级经理及以上', value: 'C-Level高级经理及以上' },
                { text: 'IT采购人员', value: 'IT采购人员' },
                { text: '业务负责人', value: '业务负责人' },
                { text: '技术人员', value: '技术人员' },
                { text: '其它职务', value: '其它职务' },
            ],
            companySizeOptions: [
                { text: '1-25人', value: '1-25人' },
                { text: '26-99人', value: '26-99人' },
                { text: '100-499人', value: '100-499人' },
                { text: '500-999人', value: '500-999人' },
                { text: '1000-4999人', value: '1000-4999人' },
                { text: '5000-9999人', value: '5000-9999人' },
                { text: '10000+人', value: '10000+人' },
            ],
        }
    },
    directives: {
        clickoutside: {
            bind: function (el, binding, vnode) {
                function documentHandler(e) {
                    // 这里判断点击的元素是否是本身，是本身，则返回
                    if (el.contains(e.target)) {
                        return false;
                    }
                    // 判断指令中是否绑定了函数
                    if (binding.expression) {
                        // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
                        binding.value(e);
                    }
                }

                // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
                el.__vueClickOutside__ = documentHandler;
                document.addEventListener('click', documentHandler);
            },
            update: function () {
            },
            unbind: function (el, binding) {
                document.removeEventListener('click', el.__vueClickOutside__);
                delete el.__vueClickOutside__;
            }
        }
    },
    computed: {
        ...mapState([
            'site_yhxy',
            'hasCoupon',
            'couponTitle',
            'couponImg',
            'couponUrl',
        ]),
        detail_rule_pc() {
            return this.$store.state.detail_rule_pc || '';
        }
    },
    watch: {
        company(newText, oldText) {
            if (!this.isTwoChinese(newText) || !this.companySearch) return;
            if (this.companySetTime) clearTimeout(this.companySetTime);
            this.companySetTime = setTimeout(() => {
                this.axios.post('https://www.dellemc-solution.com/api/search/company', {
                    keyword: newText
                }).then(({ data }) => {
                    if (data.errCode === 0) {
                        this.companyList = data.data;
                        this.companyListShow = this.companyList.length > 0;
                        gioTrackAction('QCCcompany_impressions');  //埋点实施方案
                    }
                });
            }, 600);

        }
    },
    methods: {
        toggleMoreFields() {
            this.showMoreFields = !this.showMoreFields;
        },
        toggleRuleShow() {
            this.showRule = !this.showRule;
        },
        companyLiClick(text) {
            this.company = text;
            this.ifMatchingcompanyName = true;
            this.companySearch = false;
            this.companyListHide();
            gioTrackAction('QCCcompany_click');  //埋点实施方案
        },
        companyListHide() {
            this.companyListShow = false;
        },
        isTwoChinese(val) {
            return !!val.match(/[^\x00-\xff]/ig) && val.match(/[^\x00-\xff]/ig).length >= 2;
        },
        companyOnInput() {
            this.companySearch = true;
            this.ifMatchingcompanyName = false;
        },
        getSmarketLoginInfo: function () {
            let smarketCookie = this.cookies.get('smarketMember_498');
            if (smarketCookie) {
                smarketCookie = JSON.parse(smarketCookie);
                this.axios.post('https://api.dellemc-solution.com/member/LookUp', {
                    sess: smarketCookie.session
                }).then(res => {
                    console.log(res);
                    if (res.data.body.result == 0 && res.data.body.content.length > 0) {
                        res.data.body.content.forEach(obj => {
                            if (obj.key == "name") {
                                this.truename = obj.value;
                            } else if (obj.key == "mobile") {
                                this.tel = obj.value;
                            } else if (obj.key == "email") {
                                this.email = obj.value;
                            } else if (obj.key == "enterprise_name") {
                                this.company = obj.value;
                            } else if (obj.key == "province" && typeof obj.value == "object") {
                                this.address = obj.value.join(',');
                            }
                        })
                    }
                })
            }

        },
        //检查EMAIL
        isEmail: function (str) {
            var reg = /^\S+@\S+$/;
            var flag = reg.test(str);
            return flag;
        },
        // 显示Toast提示
        showToast(message, type = 'error') {
            this.$refs.toast.show(message, type);
        },
        submit() {

            if (!this.tongyi) return;

            if (this.truename == '') {
                this.showToast('没有填写姓名');
                return;
            }

            if (this.tel == '') {
                this.showToast('没有填写手机号');
                return;
            }

            if (this.tel.length != 11) {
                this.showToast('请填写正确的手机号');
                return;
            }

            if (this.email == '') {
                this.showToast('没有填写企业邮箱');
                return;
            }

            if (!this.isEmail(this.email)) {
                this.showToast('请填写正确的企业邮箱');
                return;
            }

            if (this.company == '') {
                this.showToast('没有填写公司全称');
                return;
            }

            /*
            if(this.address == ''){
              this.showToast('没有填写收货地址');
              return;
            }
            */
            this.address = '暂无';

            if (this.reason == '') {
                this.showToast('没有填写申请理由');
                return;
            } else {
                if (this.reason.length < 5 || this.reason.length > 150) {
                    this.showToast('申请理由5-150个字');
                    return;
                }
            }
            if (this.submitIng === true) return;
            this.submitIng = true;

            try {
                var _this = this;
                gioTrackAction('campaign0yuan_Submit', {
                    phoneNumber: common.mobileEncryption(_this.tel),
                    ifMatchingcompanyName: _this.ifMatchingcompanyName,
                });
                gioTrackAction('QCCcompany_formsubmitsuccess', {
                    phoneNumber: common.mobileEncryption(_this.tel),
                    ifMatchingcompanyName: _this.ifMatchingcompanyName,
                });
            } catch (e) {
                console.log(e);
            }
            let smarketCookie = this.cookies.get("smarketMember_498");
            let memberInfo = {};
            try {
                memberInfo = JSON.parse(smarketCookie);
            } catch (error) {

            }
            this.axios.post(solution_host + '/campaigns-b/try/index.php?_c=detail&_a=apply&source=pc&tid=' + this.$store.state.tid, {
                truename: this.truename,
                tel: this.tel,
                email: this.email,
                company: this.company,
                address: this.address,
                reason: this.reason,
                sess: memberInfo.session,
                OCSESSID: common.getCookie('OCSESSID') || '',
                source: 'pc',
                // 新增的字段
                position: this.position,
                companySize: this.companySize,
                scene: this.useCase,

                // utm参数
                utm_campaign: common.getUrlPara('utm_campaign') || '',
                utm_content: common.getUrlPara('utm_content') || '',
                utm_term: common.getUrlPara('utm_term') || '',
                utm_medium: common.getUrlPara('utm_medium') || '',
                utm_source: common.getUrlPara('utm_source') || ''
            })
                .then((response) => {

                    var d = response.data.data;
                    this.submitIng = false;
                    if (response.data.code == 500) {
                        this.showToast(response.data.msg);
                        return;
                    }
                    //console.log(response)
                    this.aid = d.aid;

                    this.showApplyConfirm = true;

                    // 数据上报接口调用，错误静默处理
                    try {
                        this.axios.post('https://www.dellemc-solution.com/api/account/acbdt', {
                            mobile: this.tel
                        }).catch(() => {
                            // 接口报错忽略，不阻断流程
                        });
                    } catch (e) {
                        // 异常忽略，不阻断流程
                    }
                })
                .catch((error) => { // 请求失败处理
                    this.submitIng = false;
                    this.showToast('提交失败，请稍后重试');
                    console.log(error);
                });


            //this.$store.commit('setApplyformShow',false);
        },
        cancel() {
            this.showApplyConfirm = false;
            this.$store.commit('setApplyformShow', false);
        },
        go() {
            this.showApplyConfirm = false;
            this.$store.commit('setApplyformShow', false);
            // 通过EventBus触发detail页面的showWechatQrCode方法
            this.$root.$emit('showWechatQrCode');
        },
        setApplyformShow(val) {
            this.$store.commit('setApplyformShow', val);
        },
        clickCoupon() {
            if (this.hasCoupon) {
                window.open(this.couponUrl);
            }
        },
    },

    props: ['tid'],
    beforeDestroy() {
        console.log('applyeform beforeDestroy')
    },
    created() {
        console.log('applyform   created')
        this.getSmarketLoginInfo();
    }
}
</script>
<style scoped lang="scss">
.btn {
    outline: none;
    border: none;
    display: block;
    margin: 30px auto 20px;
    width: 200px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    font-size: 16px;
    color: #fff;
    background: linear-gradient(-90deg, #a32928 1%, #d41c1c 100%);
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
        background: linear-gradient(-90deg, #8b2221 1%, #b91818 100%);
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(163, 41, 40, 0.3);
    }

    &:active {
        transform: translateY(0);
        box-shadow: 0 2px 6px rgba(163, 41, 40, 0.3);
    }

    &.disabled {
        background: #ccc;
        cursor: not-allowed;
        transform: none;
        box-shadow: none;

        &:hover {
            background: #ccc;
            transform: none;
            box-shadow: none;
        }
    }
}


.applyform {
    background-color: rgb(0 0 0 / 48%);
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 102;
    display: flex;
    align-items: center;
    justify-content: center;

    .body {
        width: 600px;
        max-width: 90vw;
        background: #fff;
        border-radius: 8px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
        overflow: hidden;
    }

    .body-content {
        width: 100%;
        max-height: 70vh;
        overflow-y: auto;

        /* 自定义滚动条样式 */
        &::-webkit-scrollbar {
            width: 8px;
        }

        &::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 4px;
        }

        &::-webkit-scrollbar-thumb {
            background: #c1c1c1;
            border-radius: 4px;
            transition: background 0.3s ease;

            &:hover {
                background: #a8a8a8;
            }
        }

        &::-webkit-scrollbar-thumb:active {
            background: #888;
        }

        /* Firefox 滚动条样式 */
        scrollbar-width: thin;
        scrollbar-color: #c1c1c1 #f1f1f1;
    }

    .body-main {
        position: relative;
        width: 100%;
        padding: 40px 50px;

        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;

            .iconfont {
                font-size: 24px;
                color: #9c9c9c;
                transition: color 0.3s;

                &:hover {
                    color: #666;
                }
            }
        }
    }

    .body-title {
        text-align: center;
        font-size: 24px;
        font-weight: bold;
        color: #000;
        margin-bottom: 30px;
    }

    .row {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        position: relative;

        input[type=text] {
            outline: none;
            padding-left: 150px;
            width: 100%;
            height: 45px;
            border: 1px solid #ddd;
            border-radius: 4px;
            font-size: 14px;
            transition: border-color 0.3s;

            &:focus {
                border-color: #0e4b88;
            }

            &[type=text]::-webkit-input-placeholder {
                color: #999;
                font-weight: normal;
            }
        }

        textarea::-webkit-input-placeholder {
            color: #999;
            font-weight: normal;
        }

        textarea {
            outline: none;
            height: 120px;
            border: 1px solid #ddd;
            border-radius: 4px;
            padding: 35px 12px 15px;
            font-size: 14px;
            font-family:  sans-serif;
            color: #000000;
            line-height: 1.5;
            resize: vertical;
            transition: border-color 0.3s;

            &:focus {
                border-color: #0e4b88;
            }
        }

        .textarea-label {
            width: 200px;

            &:after {
                content: '';
            }
        }

        &>label {
            position: absolute;
            width: 100px;
            // height: 45px;
            line-height: 45px;
            font-size: 14px;
            top: 0;
            left: 15px;
            text-align: justify;
            text-align-last: justify;
            color: #333;
            font-weight: 500;

            &:after {
                content: ':';
                display: block;
                position: absolute;
                top: 0;
                right: -8px;
                height: 45px;
                line-height: 45px;
            }

            &.yinsi-text {
                position: relative;
                width: 100%;
                top: 0;
                left: 0;
                font-size: 14px;
                line-height: 1.5;
                color: #666;
                text-align: left;
                text-align-last: unset;
                font-weight: normal;

                .text-check {
                    position: relative;
                    top: 2px;
                    display: inline-block;
                    width: 16px;
                    height: 16px;
                    border: 1px solid #ddd;
                    margin-right: 8px;
                    border-radius: 2px;
                }

                .text-blue {
                    color: #0e4b88;
                    text-decoration: underline;
                    text-underline-offset: 3px;
                    text-decoration-thickness: 1px;
                    cursor: pointer;
                    position: relative;
                    z-index: 5;
                }
            }
        }

        .checkbox {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 3;
            bottom: 0;
            right: 0;
            opacity: 0;

            &:checked+.yinsi-text .text-check {
                background: url('~@/assets/check.png') top center/cover no-repeat;
                background-size: 100%;
                border: none;
            }
        }
    }

    .yinsi-div {
        height: auto;
        min-height: 50px;

        .yinsi-text::after {
            content: '';
        }
    }

    /* 展开更多信息的样式 */
    .expand-more-row {
        border-radius: 4px;
        background: #0e4b88;
        padding: 12px 15px;
        margin-top: 20px;
        color: #ffffff;

        .expand-more-text {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 14px;
            cursor: pointer;
            user-select: none;

            .expand-text {
                text-decoration: underline;
                text-underline-offset: 3px;
                text-decoration-thickness: 1px;
                transition: text-decoration-thickness 0.3s;

                &:hover {
                    text-decoration-thickness: 2px;
                }
            }

            .expand-icon {
                transition: transform 0.3s ease;
                font-size: 16px;

                &.expanded {
                    transform: rotate(180deg);
                }
            }
        }
    }

    /* 试用规则样式 */
    .rule-row {
        .rule-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 15px 0;
            cursor: pointer;

            .rule-title {
                font-size: 16px;
                font-weight: bold;
                color: #333;
            }

            .rule-icon {
                transition: transform 0.3s ease;
                font-size: 14px;
                color: #666;

                &.expanded {
                    transform: rotate(180deg);
                }
            }
        }

        .rule-content {
            padding: 20px 0;
            margin-bottom: 20px;
            font-size: 14px;
            line-height: 1.6;
            color: #666;
            border: 1px solid #e9eef4;
            border-radius: 4px;
            padding: 20px 15px;
            background-color: #f9f9f9;
            animation: slideDown 0.3s ease;
        }
    }

    /* 更多字段区域的样式 */
    .more-fields {
        animation: slideDown 0.3s ease;

        .row {
            margin-bottom: 20px;
        }
    }

    @keyframes slideDown {
        from {
            opacity: 0;
            max-height: 0;
            overflow: hidden;
        }

        to {
            opacity: 1;
            max-height: 500px;
        }
    }
}

.company-list {
    box-sizing: border-box;
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
    border-left: 1px solid #e9eef4;
    border-right: 1px solid #e9eef4;
    border-bottom: 1px solid #e9eef4;
    background-color: #fff;
    padding-left: 0;
    padding-top: 8px;
    padding-bottom: 8px;
    position: absolute;
    top: 45px;
    left: 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    z-index: 6;
    border-radius: 0 0 4px 4px;

    /* 自定义滚动条样式 */
    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: #f8f8f8;
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
        background: #d0d0d0;
        border-radius: 3px;
        transition: background 0.3s ease;

        &:hover {
            background: #b0b0b0;
        }
    }

    &::-webkit-scrollbar-thumb:active {
        background: #999;
    }

    /* Firefox 滚动条样式 */
    scrollbar-width: thin;
    scrollbar-color: #d0d0d0 #f8f8f8;

    li {
        box-sizing: border-box;
        width: 100%;
        padding-left: 15px;
        height: 40px;
        line-height: 40px;
        text-align: left;
        color: #666;
        transition: all 0.3s;
        cursor: pointer;
        font-size: 14px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        &:hover {
            background-color: #f5f5f5;
            color: #333;
        }
    }
}

.applyAlert {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-color: rgb(0 0 0 / 48%);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;

    .body2 {
        padding: 40px 50px;
        width: 600px;
        max-width: 90vw;
        max-height: 80vh;
        background-color: #fff;
        border-radius: 8px;
        position: relative;
        font-size: 16px;
        text-align: left;
        box-sizing: border-box;
        overflow-y: auto;

        /* 自定义滚动条样式 */
        &::-webkit-scrollbar {
            width: 8px;
        }

        &::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 4px;
        }

        &::-webkit-scrollbar-thumb {
            background: #c1c1c1;
            border-radius: 4px;
            transition: background 0.3s ease;

            &:hover {
                background: #a8a8a8;
            }
        }

        &::-webkit-scrollbar-thumb:active {
            background: #888;
        }

        /* Firefox 滚动条样式 */
        scrollbar-width: thin;
        scrollbar-color: #c1c1c1 #f1f1f1;
    }

    .close {
        position: absolute;
        top: 20px;
        width: 30px;
        right: 20px;
        cursor: pointer;
    }
}

.apply-mask {
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgb(0 0 0 / 48%);
    left: 0;
    top: 0;
}

.applyConfirm {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 500px;
    max-width: 90vw;
    display: flex;
    flex-flow: column;
    z-index: 10;
    border-radius: 8px;
    background-color: #fff;
    text-align: center;
    padding: 50px 40px 40px;

    .content {
        .coupon-infor {
            font-size: 14px;
            padding-bottom: 8px;
        }

        .title {
            font-size: 24px;
            font-weight: bold;
            color: #000000;
            margin-bottom: 30px;
        }

        .text {
            font-size: 14px;
            color: #666;
            line-height: 1.5;
        }

        .coupon-img {
            margin-top: 25px;
            width: 200px;
            height: 200px;
        }

        .success-img {
            margin-top: 25px;
            width: 200px;
            height: 160px;
        }

        .btnGroup {
            margin: 30px 0 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 15px;

            button {
                @extend .btn;
                margin: 0 !important;
                font-size: 16px;
                border-radius: 4px;
                cursor: pointer;
                transition: all 0.3s;
            }

            .btn-line {
                color: #a32928;
                background-image: none;
                background-color: #fff;
                border: 1px solid #a32928;

                &:hover {
                    background-color: #a32928;
                    color: #fff;
                }
            }
        }
    }

    .close-icon {
        position: absolute;
        z-index: 1;
        right: 15px;
        top: 15px;
        cursor: pointer;

        .iconfont {
            font-size: 24px;
            color: #999;
            transition: color 0.3s;

            &:hover {
                color: #666;
            }
        }
    }
}

/* 1280分辨率适配 */
@media screen and (max-width: 1280px) {
    .applyform {
        .body {
            width: 550px;
            max-width: 85vw;
        }

        .body-main {
            padding: 35px 40px;
        }

        .body-title {
            font-size: 22px;
            margin-bottom: 25px;
        }

        .row {
            margin-bottom: 18px;

            input[type=text] {
                padding-left: 130px;
                height: 42px;
                font-size: 13px;
            }

            textarea {
                height: 110px;
                padding: 32px 12px 12px;
                font-size: 13px;
            }

            &>label {
                width: 90px;
                line-height: 42px;
                font-size: 13px;
                left: 12px;

                &:after {
                    height: 42px;
                    line-height: 42px;
                    right: -6px;
                }

                &.yinsi-text {
                    font-size: 13px;
                    line-height: 1.4;

                    .text-check {
                        width: 15px;
                        height: 15px;
                        margin-right: 6px;
                    }
                }
            }

            .textarea-label {
                width: 180px;
            }
        }

        .expand-more-row {
            padding: 10px 12px;
            margin-top: 18px;

            .expand-more-text {
                font-size: 13px;

                .expand-icon {
                    font-size: 15px;
                }
            }
        }

        .rule-row {
            .rule-header {
                padding: 12px 0;

                .rule-title {
                    font-size: 15px;
                }

                .rule-icon {
                    font-size: 13px;
                }
            }

            .rule-content {
                padding: 18px 12px;
                margin-bottom: 18px;
                font-size: 13px;
                line-height: 1.5;
            }
        }

        .more-fields {
            .row {
                margin-bottom: 18px;
            }
        }
    }

    .btn {
        width: 180px;
        height: 42px;
        line-height: 42px;
        font-size: 15px;
        margin: 25px auto 18px;
    }

    .company-list {
        max-height: 180px;
        padding-top: 6px;
        padding-bottom: 6px;
        top: 42px;

        li {
            padding-left: 12px;
            height: 36px;
            line-height: 36px;
            font-size: 13px;
        }
    }

    .applyAlert {
        .body2 {
            padding: 35px 40px;
            width: 550px;
            max-width: 85vw;
            font-size: 15px;
        }

        .close {
            width: 28px;
            top: 18px;
            right: 18px;
        }
    }

    .applyConfirm {
        width: 450px;
        max-width: 85vw;
        padding: 45px 35px 35px;

        .content {
            .coupon-infor {
                font-size: 13px;
                padding-bottom: 6px;
            }

            .title {
                font-size: 22px;
                margin-bottom: 25px;
            }

            .text {
                font-size: 13px;
                line-height: 1.4;
            }

            .coupon-img {
                margin-top: 20px;
                width: 180px;
                height: 180px;
            }

            .success-img {
                margin-top: 20px;
                width: 180px;
                height: 144px;
            }

            .btnGroup {
                margin: 25px 0 0;
                gap: 12px;

                button {
                    width: 160px;
                    height: 40px;
                    line-height: 40px;
                    font-size: 15px;
                }
            }
        }

        .close-icon {
            right: 12px;
            top: 12px;

            .iconfont {
                font-size: 22px;
            }
        }
    }
}

/* 1280分辨率以下进一步优化 */
@media screen and (max-width: 1024px) {
    .applyform {
        .body {
            width: 500px;
            max-width: 90vw;
        }

        .body-main {
            padding: 30px 35px;
        }

        .body-title {
            font-size: 20px;
            margin-bottom: 20px;
        }

        .row {
            margin-bottom: 16px;

            input[type=text] {
                padding-left: 120px;
                height: 40px;
                font-size: 12px;
            }

            textarea {
                height: 100px;
                padding: 30px 10px 10px;
                font-size: 12px;
            }

            &>label {
                width: 85px;
                line-height: 40px;
                font-size: 12px;
                left: 10px;

                &:after {
                    height: 40px;
                    line-height: 40px;
                    right: -5px;
                }

                &.yinsi-text {
                    font-size: 12px;
                    line-height: 1.3;

                    .text-check {
                        width: 14px;
                        height: 14px;
                        margin-right: 5px;
                    }
                }
            }

            .textarea-label {
                width: 160px;
            }
        }

        .expand-more-row {
            padding: 8px 10px;
            margin-top: 16px;

            .expand-more-text {
                font-size: 12px;

                .expand-icon {
                    font-size: 14px;
                }
            }
        }

        .rule-row {
            .rule-header {
                padding: 10px 0;

                .rule-title {
                    font-size: 14px;
                }

                .rule-icon {
                    font-size: 12px;
                }
            }

            .rule-content {
                padding: 15px 10px;
                margin-bottom: 16px;
                font-size: 12px;
                line-height: 1.4;
            }
        }
    }

    .btn {
        width: 160px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        margin: 20px auto 16px;
    }

    .company-list {
        max-height: 160px;
        top: 40px;

        li {
            padding-left: 10px;
            height: 34px;
            line-height: 34px;
            font-size: 12px;
        }
    }

    .applyAlert {
        .body2 {
            padding: 30px 35px;
            width: 500px;
            max-width: 90vw;
            font-size: 14px;
        }

        .close {
            width: 26px;
            top: 15px;
            right: 15px;
        }
    }

    .applyConfirm {
        width: 400px;
        max-width: 90vw;
        padding: 40px 30px 30px;

        .content {
            .coupon-infor {
                font-size: 12px;
                padding-bottom: 5px;
            }

            .title {
                font-size: 20px;
                margin-bottom: 20px;
            }

            .text {
                font-size: 12px;
                line-height: 1.3;
            }

            .coupon-img {
                margin-top: 18px;
                width: 160px;
                height: 160px;
            }

            .success-img {
                margin-top: 18px;
                width: 160px;
                height: 128px;
            }

            .btnGroup {
                margin: 20px 0 0;
                gap: 10px;

                button {
                    width: 140px;
                    height: 38px;
                    line-height: 38px;
                    font-size: 14px;
                }
            }
        }

        .close-icon {
            right: 10px;
            top: 10px;

            .iconfont {
                font-size: 20px;
            }
        }
    }
}
</style>
